import React from 'react';
import ReactECharts from 'echarts-for-react';

const SafeChart = ({ option, style, height = '300px' }) => {
  // Fallback hvis ingen konfigurasjon sendes med
  if (!option) {
    return (
      <div className="w-full bg-slate-50 rounded-2xl flex flex-col items-center justify-center border-2 border-dashed border-slate-200" style={{ ...style, minHeight: height }}>
        <p className="text-slate-400 font-bold text-xs uppercase tracking-widest">Ingen data å vise</p>
      </div>
    );
  }

  // Standardinnstillinger for charts for å matche designet
  const defaultOption = {
    ...option,
    grid: {
      top: 30,
      right: 20,
      bottom: 20,
      left: 20,
      containLabel: true,
      ...option.grid
    },
    textStyle: {
      fontFamily: '"Plus Jakarta Sans", sans-serif'
    }
  };

  return (
    <div style={{ width: '100%', height: '100%', minHeight: height, ...style }}>
      <ReactECharts 
        option={defaultOption} 
        style={{ height: '100%', width: '100%' }}
        opts={{ renderer: 'svg' }} // Bruker SVG for skarpere rendering
      />
    </div>
  );
};

export default SafeChart;